import {
  getFilterHistoryModel,
  getFilterHistoryStorageModel,
  getSearchAccordionOpenSettingModel,
} from '@/features/search/_utils/local-storage';
import { z } from 'zod';

export const WorkflowSearchAccordionOpenSettingValueModel = z.object({
  workflow: z.boolean(),
});
export const WorkflowSearchAccordionOpenSettingModel =
  getSearchAccordionOpenSettingModel(
    WorkflowSearchAccordionOpenSettingValueModel,
  );
const WorkflowFilterHistoryModel = getFilterHistoryModel();
export const WorkflowFilterHistoryStorageModel = getFilterHistoryStorageModel(
  WorkflowFilterHistoryModel,
);
